import { render, staticRenderFns } from "./hotelPolicies.vue?vue&type=template&id=d04328be"
import script from "./hotelPolicies.vue?vue&type=script&lang=js"
export * from "./hotelPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports